<template>
  <div v-if="show" class="wrapper-file-empty">
    <t-icon class="icon" :icon="['fal', 'info-circle']" />
    <h2 class="title" v-text="title" />
    <p v-if="content" class="content" v-html="content" />
    <button v-if="hideButton" class="ui button btn-link" @click="action" v-text="titleButton" />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    titleButton: {
      type: String,
      default: ''
    },
    hideButton: {
      type: Boolean,
      default: false
    },
    hideBack: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    action () {
      this.$emit(this.action)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/colors.scss";

.wrapper-file-empty {
  background-color: hsla(210, 17%, 95%, 0.9);
  position: fixed;
  width: 100%;
  height: calc(100vh - 220px);
  left: 0;
  bottom: 0;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;

  .icon {
    font-size: 96px;
    color: $blue-500;
  }

  .title {
    font-weight: 700;
    font-size: 25px;
    line-height: 36px;
    margin-top: 35px;
    margin-bottom: 20px;
  }

  .content {
    font-weight: normal;
    font-size: 16px;
    line-height: 23px;
    color: $gray-600;
    text-align: center;
  }

  .btn-link {
    background-color: transparent;
    border: 0;
    color: $blue-500;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    padding: 0;
    cursor: pointer;

    &:hover,
    &:focus {
      outline: none;
      box-shadow: none;
      color: $blue-700;
    }
  }
}
</style>
